import { render } from "./StockTransfers.vue?vue&type=template&id=fa4d9af2&scoped=true"
import script from "./StockTransfers.vue?vue&type=script&lang=js"
export * from "./StockTransfers.vue?vue&type=script&lang=js"

import "./StockTransfers.vue?vue&type=style&index=0&id=fa4d9af2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa4d9af2"]])

export default __exports__